<template>
  <q-field
    dense
    :model-value="modelValue"
    :label="label"
    :error="error"
    :error-message="errorMessage"
    :disable="disable"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #control="{ id, floatingLabel, modelValue: valor, emitValue }">
      <money-input
        :id="id"
        v-show="floatingLabel"
        class="q-field__native text-right"
        :value="valor"
        v-bind="FORMATO"
        @input="(novo) => floatingLabel && emitValue(novo)"
      />
    </template>
  </q-field>
</template>

<script>
import MoneyInput from "@/components/Utils/money-input.vue";

const FORMATO = { decimal: ",", thousands: ".", prefix: "R$ ", precision: 2, masked: false };

export default {
  name: "CampoValor",
  components: { MoneyInput },
  props: {
    modelValue: { type: Number, default: null },
    label: { type: String, default: "" },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: "" },
    disable: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  data() {
    return { FORMATO };
  }
};
</script>
